import * as React from 'react'
import {StrictMode} from 'react'
import * as ReactDOM from 'react-dom'
import App from './App';
import * as serviceWorker from './serviceWorker';
import './assets/style/style.scss';
import configureStore from './configureStore'
import {createBrowserHistory} from 'history'
import 'typeface-ibm-plex-sans';
import 'react-toastify/dist/ReactToastify.css';
import {Provider} from "react-redux";
import ReactPWAInstallProvider from "react-pwa-install";

const history = createBrowserHistory()
const initialState = window.INITIAL_REDUX_STATE
export const store = configureStore(history, initialState)


ReactDOM.render(
    <StrictMode>
        <ReactPWAInstallProvider enableLogging>
            <Provider store={store}>
                <App history={history}/>
            </Provider>
        </ReactPWAInstallProvider>
    </StrictMode>,
    document.getElementById('root')
);

serviceWorker.register();